<template>
    <b-card class="border mb-0" no-body>
        <b-card-body class="d-flex justify-content-between align-items-center">
            <div class="truncate">
                <h2 class="mb-25 font-weight-bolder">
                    <span v-if="loading" class="v-stats-skeleton"></span>
                    <template v-else>{{value}}</template>
                </h2>
                <span>{{text}}</span> <template v-if="shortText">(<short-text :text="shortText"></short-text>)</template>
            </div>
            <b-avatar :variant="['light',variant].join('-')" size="45">
                <b-spinner small v-if="loading" :variant="variant"></b-spinner>
                <span v-else class="material-icons-round">{{icon}}</span>
            </b-avatar>
        </b-card-body>
    </b-card>
</template>

<script>
import { BCard, BAvatar,BCardBody,BSpinner } from "bootstrap-vue";
import ShortText from "@/components/ShortText";
export default {
    components:{
        BCard,
        BAvatar,
        BCardBody,
        BSpinner,
        ShortText
    },
    props:{
        value:[String,Number],
        text:String,
        icon:String,
        shortText:String,
        variant:{
            type:String,
            default:"primary"
        },
        loading:{
            type:Boolean,
            default:false
        }
    },
}
</script>

<style scoped>
.v-stats-skeleton{
    display:inline-block;
    width:85%;
    min-width:70px;
    height:1.6rem;
    border-radius:0.35rem;
    background:linear-gradient(90deg,#cfd4da 25%,#eaedf0 37%,#cfd4da 63%);
    background-size:400% 100%;
    animation:v-stats-shimmer 1.1s ease-in-out infinite;
    vertical-align:middle;
}
@keyframes v-stats-shimmer{
    0%{ background-position:100% 50%; }
    100%{ background-position:0 50%; }
}
</style>